// extracted by mini-css-extract-plugin
export default {"replyButton":"v8x62","replyIcon":"_3sgUI"};